export default __webpack_public_path__ + "static/media/lotus-yellow.1ea22878.png";